module.exports = __webpack_public_path__ + "media/images/prevention_form/gaming-3c7aef6d6a96f17f01976f47cb880ca3.svg";